import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import Vuetify from 'vuetify'
// import {VProgressLinear} from 'vuetify'
import router from "./router";
require("vue-flash-message/dist/vue-flash-message.min.css");
import "vuetify/dist/vuetify.min.css";
import "material-design-icons-iconfont/dist/material-design-icons.css";

import VueTabs from 'vue-nav-tabs'
import 'vue-nav-tabs/themes/vue-tabs.css'
Vue.use(VueTabs)
import Axios from "axios";
import VueNumeric from "vue-numeric";
import VueCurrencyFilter from 'vue-currency-filter'
import {URL} from '../env'

Axios.create({baseURL: URL})

Axios.interceptors.request.use(function (config) {
  let token = localStorage.getItem('access_token')
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`
  }
  let tenantId = sessionStorage.getItem("X-TENANT");
  // config.baseURL = "http://localhost:8000/";
  if(tenantId) {
    config.headers["X-TENANT"] = tenantId;
  }
  config.headers['Content-Type'] = 'application/json'
  config.headers['Accept'] = 'application/json'
  return config;
}, function (error) {
  // Do something with request error
  return Promise.reject(error);
});

Vue.use(VueCurrencyFilter,
{
  symbol : '$',
  thousandsSeparator: ',',
  fractionCount: 2,
  fractionSeparator: '.',
  symbolPosition: 'front',
  symbolSpacing: false
})

import VueFlashMessage from "vue-flash-message";
Vue.use(VueRouter)
const vuetifyOptions = { 
  // components:{
  //   VProgressLinear
  // }
}
Vue.use(Vuetify , vuetifyOptions);
Vue.use(VueFlashMessage);
Vue.use(VueNumeric);

Vue.config.productionTip = false
export const EventBus = new Vue();
new Vue({
  render: h => h(App),
  router: router,
  // vuetify: new Vuetify(vuetifyOptions)
}).$mount('#app')
